import React from "react";
import { TFunction } from "i18next";

import ModalLoading from "@components/Common/ModalLoading";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { SupportCodeModal } from "@pages/Applications/DeviceAssociateModal/MoneticsApplicationForm/SupportCodeModal";

import { ConfirmationActiveFidelity } from "../ConfirmationActiveFidelity";
import HistoryModal from "../HistoryModal";

type Props = {
    isActionsClicked: boolean;
    setIsActionsClicked: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirm: () => void;
    onCancel: () => void;
    setIsEdited: React.Dispatch<React.SetStateAction<boolean>>;
    isModalOpened: boolean;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    isInInitializationModalOpened: boolean;
    setIsInInitializationModalOpened: React.Dispatch<
        React.SetStateAction<boolean>
    >;
    isAddNewFidelityButtonClicked: boolean;
    setIsAddNewFidelityButtonClicked: React.Dispatch<
        React.SetStateAction<boolean>
    >;
    isHistoryModalOpened: boolean;
    setIsHistoryModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<number | boolean>>;
    isModalOpenedSupport: boolean;
    setIsModalOpenedSupport: React.Dispatch<React.SetStateAction<boolean>>;
    codeSupport: string;
    setCodeSupport: React.Dispatch<React.SetStateAction<string>>;
    isValidCode: boolean;
    setIsValidCode: React.Dispatch<React.SetStateAction<boolean>>;
    isLoading: boolean;
    t: TFunction;
};

export default function FidelityModals({
    isActionsClicked,
    setIsActionsClicked,
    onConfirm,
    onCancel,
    setIsEdited,
    isModalOpened,
    setIsModalOpened,
    isInInitializationModalOpened,
    setIsInInitializationModalOpened,
    isAddNewFidelityButtonClicked,
    setIsAddNewFidelityButtonClicked,
    isHistoryModalOpened,
    setIsHistoryModalOpened,
    setDataIsUpdated,
    isModalOpenedSupport,
    setIsModalOpenedSupport,
    codeSupport,
    setCodeSupport,
    isValidCode,
    setIsValidCode,
    isLoading,
    t,
}: Props) {
    return (
        <React.Fragment>
            {isActionsClicked ? (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={onCancel}
                    actions={onConfirm}
                    setIsEdited={setIsEdited}
                />
            ) : null}

            {isModalOpened ? (
                <ConfirmationActiveFidelity
                    setIsModalOpened={setIsModalOpened}
                    isModalOpened={isModalOpened}
                />
            ) : null}

            {isInInitializationModalOpened ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewFidelityButtonClicked}
                    isClicked={isAddNewFidelityButtonClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}

            {isHistoryModalOpened ? (
                <HistoryModal
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                    setDataUpdated={setDataIsUpdated}
                />
            ) : null}

            {isModalOpenedSupport ? (
                <SupportCodeModal
                    isModalOpened={isModalOpenedSupport}
                    setIsModalOpened={setIsModalOpenedSupport}
                    codeSupport={codeSupport}
                    setCodeSupport={setCodeSupport}
                    isValidCode={isValidCode}
                    setIsValidCode={setIsValidCode}
                />
            ) : null}

            {isLoading ? (
                <ModalLoading
                    isOpen={isLoading}
                    data={{
                        title: t("Alert"),
                        message: t("The action is currently being processed."),
                    }}
                />
            ) : null}
        </React.Fragment>
    );
}
